// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"aee1dd8c","66":"8c918e55","145":"85ff6d03","190":"1d67904f","613":"4020565a","906":"464b6d15","948":"66518d8e","957":"b6eb8cd0","969":"daed3506"}[chunkId] + ".chunk.js";
};